import { useState } from 'react';
import { STATUS_BADGE } from '../../../../../constants/consumers';
import { Spinner } from '../../../../../components/Spinner';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';

function ConsumerPopoverStatusForm({ consumerStatus, updateConsumer }) {
  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const [silentUpdate, setSilentUpdate] = useState(false);

  const handleToggle = () => {
    setSilentUpdate(false);
    setIsOpen(!isOpen);
  };

  const handleStatusClick = async status => {
    setSpinner(true);
    await updateConsumer({ status, silentUpdate });
    setSpinner(false);
    handleToggle();
  };

  if (!STATUS_BADGE[consumerStatus]) {
    return null;
  }

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-start"
      show={isOpen}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 6] } }] }}
      overlay={
        <Popover className="custom-popover">
          <Popover.Body className="bo-consumer-popover-form-menu">
            <Spinner visible={spinner} size={36}>
              <div className="d-flex flex-column gap-2">
                {Object.entries(STATUS_BADGE).map(([key, value]) => (
                  <Button
                    key={key}
                    className="bo-common-base-button"
                    onClick={() => handleStatusClick(key)}
                  >
                    <Badge
                      className="bo-inline-badge bo-consumer-inline-badge-hover shadow-sm bo-w-180"
                      bg={value?.color}
                    >
                      {value?.text}
                    </Badge>
                  </Button>
                ))}
              </div>
              <div className="d-flex align-items-center ms-1 my-3">
                <Form.Check
                  className="m-0 position-relative"
                  checked={silentUpdate}
                  onChange={e => setSilentUpdate(e.target.checked)}
                />
                <Form.Label className="bo-consumer-text text-nowrap">
                  Do not send notification
                </Form.Label>
              </div>
              <div className="d-flex justify-content-center">
                <Button className="bo-common-button" onClick={handleToggle}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      }
    >
      <Button onClick={handleToggle} className="bo-consumer-popover-form-toggle me-2">
        <Badge
          className="bo-consumer-inline-badge bo-w-80"
          bg={STATUS_BADGE[consumerStatus]?.color}
        >
          {STATUS_BADGE[consumerStatus]?.text}
        </Badge>
      </Button>
    </OverlayTrigger>
  );
}

export default ConsumerPopoverStatusForm;
